import isPlainObject from 'lodash/isPlainObject';
import type {
  CandidateFormEmbeddedIdentifiers,
  CandidateFormIdentifiers,
} from '../components/candidate-form-embedded';

export const hasIdsOrSlugs = ({
  formId,
  formSlug,
  companyId,
  companySlug,
}: CandidateFormIdentifiers) =>
  !!((formId && companyId) || (formSlug && companySlug));

export const isEmbeddedIdentifiersObject = (
  opts: unknown,
): opts is CandidateFormEmbeddedIdentifiers => isPlainObject(opts);

// Prefix for static classnames that embedders can use to overwrite styling
// Warning: changing this may break their styling
export const embeddedClassNamesPrefix = 'beamery-convert';
